import { From, To } from '../Responsive';
import { getWbAssetUrl } from '../../lib/contentful/selectors.mjs';

/**
 * A video that can be rendered.
 *
 * @typedef {object} Video
 * @property {string} url - The url from which to fetch the video.
 * @property {string} contentType - The videos content type.
 */

/**
 * Renders a mobile or desktop video depending on the current screen size.
 * This component does not make any assumptions about how the video should be
 * styled and instead accepts an object of classNames to apply to the
 * component.
 *
 * @param {object} props - The props!
 * @param {object} props.classNames - The classNames to apply to the component.
 * @param {string} props.classNames.container - The class name to apply to the
 *   container that wraps the video.
 * @param {string} props.classNames.desktopVideo - The class name to apply to
 *   the desktop video.
 * @param {string} props.classNames.mobileVideo - The class name to apply to the
 *   mobile video.
 * @param {object} props.videos - The mobile and desktop videos to render.
 * @param {Video} props.videos.desktopVideo - The desktop video to render.
 * @param {Video} props.videos.mobileVideo - The mobile video to render.
 * @param {Image} props.poster - The poster image to render if video breaks.
 * @returns {JSX.Element}
 */
export function ResponsiveVideo({ classNames = {}, videos, poster, ...rest }) {
  if (!videos.desktopVideo || !videos.mobileVideo) return null;

  return (
    <div className={classNames.container}>
      <From slice={3}>
        <video
          src={getWbAssetUrl(videos.desktopVideo.url)}
          type={videos.desktopVideo.contentType}
          className={classNames.desktopVideo}
          poster={poster}
          {...rest}
        />
      </From>
      <To slice={2}>
        <video
          src={getWbAssetUrl(videos.mobileVideo.url)}
          type={videos.mobileVideo.contentType}
          className={classNames.mobileVideo}
          poster={poster}
          {...rest}
        />
      </To>
    </div>
  );
}
